module.exports = __webpack_public_path__ + "img/j2.a33ff717.jpeg";